module.exports = __webpack_public_path__ + "my.svg?591d1e38714cc55a73f3b556f00afb11";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/my.svg
// module id = 1270
// module chunks = 0